import { gql } from 'apollo-angular';


export const REQUEST_ITEM = gql`
    mutation AddProductInquiry($input: SubmitProductInquiryInput!) {
        addProductInquiry(input: $input) {
            id
        }
    }
`;